import React from 'react';
import { connect } from 'react-redux';
import { pathOr } from 'ramda';
import ErrorBoundary from 'react-error-boundary';
import PageEditorLayout from './PageEditorLayout';
import ErrorFallback from '../ErrorFallback';
import Flow from '../flow';
import PageStore from '../../stores/page';
import connectToStores from 'alt-store-connect';
import { notify } from '../../utils/errors';
import { generateRouteUrl } from '../../utils/core';
import { navigate } from '@reach/router';

@connectToStores
class PageEditorContainer extends React.Component {

    static getStores() {
        return [PageStore];
    }

    static getPropsFromStores() {
        return {
            page: PageStore.getState(),
        };
    }

    navigateToPageUrl = () => {
        const route = generateRouteUrl({
            tabType: 'page',
            tenantId: this.props.tenantId,
            options: {
                pageId: this.props.pageId,
            },
        });

        navigate(route, { replace: true });
    }

    render() {

        // The Page system flow accepts a "new" or "edit" command input
        // which determines whether the flow performs a "create" or "update" on the page.
        // If a page model exists in the Alt store which already has the command key set to "edit"
        // then we should send that to the system flow, otherwise just send the "new" command.
        const command = pathOr(this.props.command, ['page', 'models', this.props.pageId, 'editing', 'command'], this.props);

        const inputs = [
            { 'FlowId To Import': this.props.flowId || '' },
            { FlowId: '' },
            { PageId: this.props.pageId },
            { Command: command },
            { 'Editor Id': this.props.id },
        ];

        const style = {
            zIndex: this.props.id,
        };

        const className = ['page-editor-container'];
        if (this.props.isActive) {
            style.zIndex = 100;
            className.push('active');
        } else {
            style.display = 'none';
        }

        const options = {
            syncOnUnload: false,
        };

        const callbacks = [];

        /**
         * This callback has been added in because the Tooling url
         * needs to update from /:new_page to /:pages/:page_id
         * when the page is saved for the first time.
         * The only point the Tooling actually knows the system flow has
         * saved the page is when the system flow calls back.
         */
        if (command === 'new') {
            callbacks.push({
                execute: this.navigateToPageUrl.bind(this),
                type: 'forward',
                mapElement: 'dc7815e6-b83c-49a6-8a81-63260efac017',
                repeat: false,
            });
        }

        const key = (this.props.page.editorKey[this.props.pageId] === undefined ? this.props.pageId : this.props.page.editorKey[this.props.pageId]);

        return (
            <div className={className.join(' ')} style={style}>
                {!manywho.isBetaMode ?
                    (
                        <ErrorBoundary 
                            FallbackComponent={ErrorFallback} 
                            onError={(error, info) => {
                                notify({
                                    error,
                                    params: {
                                        flowId: this.props.flowId,
                                        pageId: this.props.pageId,
                                        editorId: this.props.id,
                                        componentStack: info,                
                                    },
                                });
                            }}
                        >
                            <Flow
                                tenantId={this.props.adminTenantId}
                                key={key}
                                flowName="Page"
                                component="main"
                                inputs={inputs}
                                callbacks={callbacks}
                                authenticationToken={this.props.authenticationToken}
                                options={options}
                            />
                        </ErrorBoundary>
                    ) :
                    (
                        <PageEditorLayout key={key} pageId={key} isActive={this.props.isActive} authToken={this.props.authenticationToken} />
                    )
                }
            </div>
        );

    }

}

export default connect(
    ({ currentUser: { authenticationToken, tenantId } }) => ({ authenticationToken, tenantId }),
)(PageEditorContainer);
